import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faUser } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Grid, Link, styled, Typography } from "@mui/material"
import theme from "css/theme/light"
import { ContactInfoProps } from "./ContactInfo.interfaces"
import { StyledGrid } from "./ContactInfo.styled"
import { useTranslation } from "react-i18next"

const ContactInfoCard = ({ data }: ContactInfoProps) => {
  const { name, email, phone } = data
  const { t } = useTranslation()

  const StyledIconWrapper = styled(Box)({
    backgroundColor: (theme.palette as any).primary[300],
    borderRadius: "100vh",
    height: "24px",
    width: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "8px",
  })


  return (
    <>
      <StyledGrid container direction="column" padding={4}>
        <Typography variant="h2" marginBottom={2.5}>
          {t("global.manager", "Manager")}
        </Typography>

        <Box display="flex" flexDirection="row">
          <Grid item display="flex" alignItems="flex-start">
            <StyledIconWrapper>
              <FontAwesomeIcon
                color={(theme.palette as any).primary[700]}
                icon={faUser as IconProp}
                size="sm"
              />
            </StyledIconWrapper>
            <Box display="flex" flexDirection="column" gap={0.5}>
              <Typography variant="bodyMedium" fontWeight="600" color="text.primary"> {name} </Typography>

              {email && (
                <Grid item>
                  <Link href={`mailto:${email}`} variant="bodyMedium" color="text.secondary" underline="none">
                    {email}
                  </Link>
                </Grid>
              )}
              {phone && (
                <Grid item>
                  <Link href={`tel:${phone}`} variant="bodyMedium" color="text.secondary" underline="none">
                    {phone}
                  </Link>
                </Grid>
              )}
            </Box>
          </Grid>

        </Box>
      </StyledGrid>
    </>
  )
}

export default ContactInfoCard
